import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onDeleteConflicts = new ThunderDispatcher('__onDeleteConflicts');
export const dispatch_onTriggerPanel = new ThunderDispatcher('__onTriggerPanel');
export const dispatch_onCreateExpressionClick = new ThunderDispatcher('__onCreateExpressionClick');
//# sourceMappingURL=dispatchers.js.map